import React from "react";
import { Mail, Github, Linkedin } from "lucide-react";

export default function Contact() {
    return (
        <div className="bg-slate-900 min-h-screen pb-24 pt-10">
            <section className="max-w-3xl mx-auto text-center py-8">
                <h1 className="text-4xl md:text-5xl font-extrabold text-slate-100 mb-3">
                    Let’s Work Together
                </h1>
                <p className="text-slate-400 mb-6">
                    I enjoy connecting with fellow professionals, collaborators, and new friends.<br />
                    Please use LinkedIn or email for genuine inquiries.
                </p>
            </section>

            <section className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 bg-slate-800/80 rounded-2xl shadow-lg p-8">
                {/* Contact Form - Not functional, just a placeholder */}
                <div>
                    <h2 className="text-lg font-bold text-slate-100 mb-4">Send a Message</h2>
                    <form>
                        <div className="mb-4">
                            <input
                                className="w-full rounded-lg border border-slate-700 bg-slate-900 text-slate-100 px-4 py-2"
                                placeholder="Your Name"
                                disabled
                            />
                        </div>
                        <div className="mb-4">
                            <input
                                className="w-full rounded-lg border border-slate-700 bg-slate-900 text-slate-100 px-4 py-2"
                                placeholder="Your Email"
                                disabled
                            />
                        </div>
                        <div className="mb-4">
                            <input
                                className="w-full rounded-lg border border-slate-700 bg-slate-900 text-slate-100 px-4 py-2"
                                placeholder="Subject"
                                disabled
                            />
                        </div>
                        <div className="mb-6">
                            <textarea
                                className="w-full rounded-lg border border-slate-700 bg-slate-900 text-slate-100 px-4 py-2 min-h-[80px]"
                                placeholder="Message"
                                disabled
                            />
                        </div>
                        <button
                            type="button"
                            className="w-full py-2 rounded-lg bg-cyan-700/80 text-white font-semibold cursor-not-allowed"
                            disabled
                        >
                            Send Message
                        </button>
                        <p className="text-xs text-slate-400 mt-2">
                            (Contact form is currently disabled. Please use email or LinkedIn.)
                        </p>
                    </form>
                </div>

                {/* Contact Details */}
                <div className="flex flex-col justify-center gap-6">
                    <div>
                        <h3 className="text-lg font-bold text-slate-100 mb-2">Get in Touch</h3>
                        <ul className="text-slate-300 space-y-3">
                            <li className="flex items-center gap-2">
                                <Mail className="w-5 h-5 text-cyan-400" />
                                <span>
                                    <a
                                        href="mailto:brian@brimerica.com"
                                        className="hover:underline text-cyan-200"
                                    >
                                        brian@brimerica.com
                                    </a>
                                </span>
                            </li>
                            <li className="flex items-center gap-2">
                                <Github className="w-5 h-5 text-cyan-400" />
                                <a
                                    href="https://github.com/Pb-22"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:underline text-cyan-200"
                                >
                                    GitHub
                                </a>
                            </li>
                            <li className="flex items-center gap-2">
                                <Linkedin className="w-5 h-5 text-cyan-400" />
                                <a
                                    href="https://www.linkedin.com/in/brian-williams-cyber-professional/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:underline text-cyan-200"
                                >
                                    LinkedIn
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-cyan-900/50 rounded-xl p-4 mt-6">
                        <h4 className="text-cyan-200 font-bold mb-1">About this Site</h4>
                        <p className="text-slate-300 text-sm">
                            This is a personal website and portfolio. All messages are reviewed manually.<br />
                            For collaborations, please include your LinkedIn or company site for priority.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}
